import actions from "./actions"

const initialState = {
    device: {},
    devices: []
};

export default function devicesReducers(state = initialState, action: {payload: any, type: string}):any{
    switch(action.type){
        case actions.SET_DEVICES:
            return {...state, devices: action.payload};
        case actions.SET_DEVICE:
            return {...state, device: action.payload};
        case actions.SET_INITIAL:
            return {...state, device: {}};
        default:
            return state
    }
}